var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.plat_type =='train')?_c('zhongtuoIndex'):(_vm.$route.params.plat_type =='jiazhang')?_c('jiazhangIndex'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }